import React, { Component } from 'react'
import styled, { keyframes } from 'styled-components'
import { FlexWrapper, Icon, SmallestText } from './'

const StatsFlex = styled(FlexWrapper)`
  position: relative;
  & > svg {
    position: absolute;
    bottom: -24px;
    left: 10px;
  }
`
const Stat = styled.div`
  max-width: 26px;
  position: relative;
  transform: rotate(-90deg);
  & > p {
    width: 100px;
    padding-left: 5px;
  }
`
const fillOne = keyframes`
0%{top: 100%;}  
100%{top: 25%}
`
const fillTwo = keyframes`
75%{top: 25%;}  
100%{top: 0}
`
const Bar = styled.div`
  height: 14px;
  width: ${props => (props.volume ? props.volume : 0)}px;
  background-color: ${props => (props.barColor ? props.barColor : '#fff')};
  border-radius: 0 20px 20px 0;
  position: relative;
  animation: ${fillOne} 5s forwards, ${fillTwo} 2s forwards;
  &:after {
    content: '';
    width: 8px;
    height: 8px;
    position: absolute;
    border-radius: 50%;
    top: 2px;
    right: 2px;
    z-index: 99;
    border: 0.6px solid rgba(255, 255, 255, 0.35);
  }
  &:before {
    content: '';
    width: 4px;
    height: 4px;
    background: rgba(255, 255, 255, 0.35);
    position: absolute;
    border-radius: 50%;
    right: 4.5px;
    top: 4.5px;
  }
`

class GraphBar extends Component {
  render() {
    const { icon, barColor, volume, label } = this.props
    return (
      <StatsFlex>
        <Icon color="#000" icon={icon} />
        <Stat>
          <SmallestText>{label}</SmallestText>
          <Bar
            barColor={barColor}
            volume={volume}
            /* barColor={calColor(chartData.gsCategoryWeightProcessing)}
                          volume={chartData.gsCategoryWeightProcessing} */
          />
        </Stat>
      </StatsFlex>
    )
  }
}

export default GraphBar



// WEBPACK FOOTER //
// ./src/components/GraphBar.js